/*@ngInject*/
const CreateProposalRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createProposal = function (submissionId, productTemplateIds) {
        var templateIds = '';
        angular.forEach(productTemplateIds, function (productTemplateId) {
            var str = templateIds !== '' ? '&' : '';
            templateIds += str + 'productTemplateId=' + productTemplateId;
        });
        var url = '/rest/Submission/' + submissionId + '/createProposal?' + templateIds;

        return this.post(url);
    };
};

angular.module('gw-um-submission').service('createProposalRepository', CreateProposalRepository);
